<template>
    <div class="flex-row align-items-center login">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="4">
                    <b-card no-body class="p-2">
                        <b-card-body>
                            <h2 class="mb-4">Forgot Password</h2>
                            <b-alert :show="error !=null" variant="danger">
                                {{error}}
                            </b-alert>
                            <b-form @submit="submit" v-if="!submitted">

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Email" v-model="email"></b-form-input>
                                </b-input-group>

                                <b-button type="submit" block variant="primary" class="px-4 mb-2" @click="submit">Get New Password</b-button>

                            </b-form>

                            <b-row class="links" v-if="!submitted">
                                <b-col class="text-center">
                                    <router-link :to="{name: 'login'}">Sign in instead</router-link>
                                </b-col>
                            </b-row>

                            <b-row class="message" v-if="submitted">
                                <b-col class="text-center">
                                    <p>An email has been sent to <strong>{{email}}</strong> to reset your password.</p>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ForgotPassword',
    data () {
        return {
            email: "",
            errors: null,
            error: null,
            submitted: false,
        }
    },

    methods: {
        submit(e) {
            e.preventDefault();
            if (!this.email) {
                this.error = 'Missing your email address'
                return
            }

            let data = {
                email: this.email
            }

            this.error = this.errors = null

            this.axios.post(window.location.protocol + '//' + window.location.host + '/password/email', data)
                .then(res => {
                    this.submitted = true
                })
                .catch(err => {
                    if (err.response.data.errors) {
                        this.errors = err.response.data.errors
                    }
                    this.error = err.response.data.message
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// prompts/views/pages/ForgotPassword.vue